import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Button, Modal, Typography } from "@material-ui/core";
import { vacancieUsers, titlesVacancie} from './dataPostulates';
import { Grid } from "@material-ui/core";
import ClearIcon from '@material-ui/icons/Clear';
import { IconButton } from "@material-ui/core";

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: "absolute",
    width: 450,
    backgroundColor: theme.palette.background.paper,
    boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.24)",
    outline: "none",
    borderRadius: 8,
    padding: theme.spacing(2, 4, 3),
  },
  accept: {
    background: "#E5E5E5",
    color: "#7EBDCE",
    marginRight: "5%",
    "&:hover": {
      background: "#E5E5E5",
    },
  },
  cancel: {
    background: "#7EBDCE",
    color: "white",
    "&:hover": {
      background: "#7EBDCE",
    },
  },
  text: {
    fontSize: 15,
    fontFamily: "Roboto",
    color: "#545353",
    textAlign: "center",
    margin: "25px 20px",
  },
  titleAlert: {
    fontSize: 24,
    textAlign: "center",
    fontFamily: "Roboto",
    fontWeight: "bold",
    color: "#545353",
  },
}));

const ModalConfirmBase = ({
  open,
  setOpen,
}) => {
  const classes = useStyles();
  const [modalStyle] = React.useState(getModalStyle);


  const maperTitles = (data, object) => {

    if(data.child === null){
      return object[data.field]
    } else {
      return object[data?.field][data?.child]
    }

     
  } 

  const renderButtons = (
    oneButtons,
    textButtonSubmit,
    handleClick,
    handleClickOut
  ) => {
    if (oneButtons) {
      return (
        <Button
          className={classes.cancel}
          type="button"
          variant="contained"
          color="secondary"
          onClick={handleClick}
        >
          {textButtonSubmit ? textButtonSubmit : "Aceptar"}
        </Button>
      );
    } else {
      return (
        <>
          <Button
            className={classes.accept}
            type="button"
            variant="contained"
            onClick={handleClickOut}
          >
            Cancelar
          </Button>

          <Button
            className={classes.cancel}
            type={oneButtons ? "button" : "submit"}
            variant="contained"
            color="secondary"
            onClick={handleClick}
          >
            {textButtonSubmit ? textButtonSubmit : "Aceptar"}
          </Button>
        </>
      );
    }
  };

  const bodyModal = (
    <div style={modalStyle} className={classes.paper}>
      <div>
        <IconButton style={{right: '50%'}} onClick = {() => setOpen()}>
          <ClearIcon />
        </IconButton>
        <h1 style={{marginBottom: -15, marginTop: 'auto'}}>{`${vacancieUsers?.person?.surname} ${vacancieUsers?.person?.secondSurname}`}</h1> 
        <p>CC. {vacancieUsers?.person?.documentNumber}</p>
      </div>
      <Grid container spacing={3} alignItems="center" direction="row" justify="center" >
        <Grid item lg={6} md={6} sm={6} xs={6} style={{textAlign: 'initial'}}>
        {titlesVacancie.firstGrid.map((x)=> 
          <React.Fragment >
            <div style={{marginBottom: 10}}>
              <Typography style={{fontWeight: 'bold', fontSize: 14}}>{x.title}</Typography>
              <Typography style={{fontWeight: 'normal', fontSize: 12}}>{maperTitles(x, vacancieUsers)}</Typography>
            </div>
          </React.Fragment>
        )}
        </Grid>
        <Grid item lg={6} md={6} sm={6} xs={6} style={{textAlign: 'initial'}}>
        {titlesVacancie.secondGrid.map((x)=> 
          <React.Fragment >
            <div style={{marginBottom: 10}}>
              <Typography style={{fontWeight: 'bold', fontSize: 14}}>{x.title}</Typography>
              <Typography style={{fontWeight: 'normal', fontSize: 12}}>{maperTitles(x, vacancieUsers)}</Typography>
            </div>
          </React.Fragment>
        )}
        </Grid>
      </Grid>
      <div style={{ display: "flex", justifyContent: "center" }}>
      </div>
    </div>
  );

  return (
    <div>
      <Modal
        style={{ textAlign: "center" }}
        open={open}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        {bodyModal}
      </Modal>
    </div>
  );
};

export default ModalConfirmBase;
